export const props = { viewBox: "0 0 24 24" };
export const innerHTML =
    '<path d="M7.15375 20.6542L2.5 16.0004L7.15375 11.3467L8.223 12.4004L5.373 15.2504H20.5V16.7504H5.373L8.223 19.6004L7.15375 20.6542ZM16.8462 12.6542L15.777 11.6004L18.627 8.75043H3.5V7.25043H18.627L15.777 4.40043L16.8462 3.34668L21.5 8.00043L16.8462 12.6542Z" fill="currentcolor"/>';
